import { GET_ALL_USERS,CREATE_TICKET } from "./Constants";

const initialState = {
  users: [],
  loadingUsers: false,
  errorUsers: null,
};

const initialCreateTicketState = {
  creating: false,
  createdTicket: null,
  createSuccess: false,
  createError: null,
  updating:false
};

export function allUsersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_USERS.GET_ALL_USERS_LOAD:
      return {
        ...state,
        loadingUsers: true,
        errorUsers: null,
      };

    case GET_ALL_USERS.GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        loadingUsers: false,
        users: action.data.data,
      };

    case GET_ALL_USERS.GET_ALL_USERS_FAIL:
      return {
        ...state,
        loadingUsers: false,
        errorUsers: action.error,
      };

    default:
      return state;
  }
}



export function createTicketReducer(state = initialCreateTicketState, action) {
  switch (action.type) {
    case CREATE_TICKET.CREATE_TICKET_LOAD:
      return {
        ...state,
        creating: true,
        createError: null,
        updating:true
      };

    case CREATE_TICKET.CREATE_TICKET_SUCCESS:
      return {
        ...state,
        creating: false,
        createdTicket: action.data,
        createSuccess: true,
        updating:false
      };

    case CREATE_TICKET.CREATE_TICKET_FAIL:
      return {
        ...state,
        creating: false,
        createError: action.error,
        createSuccess: false,
        updating:false
      };
      case CREATE_TICKET.CREATE_TICKET_RESET:
      return {
         ...state,
        creating: false,
        createError: null,
        createSuccess: false,
        updating:false
      }

    default:
      return state;
  }
}